import React, { useEffect, useState } from 'react';
import { WhatsAppButton } from './WhatsAppButton';
import { BrandChips } from './BrandChips';
export function Hero() {
  const heroImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/3vqpTeUqyAdXjJY8d4xyLs/ChatGPT_Image_29_may_2026,_21_08_52.png',
    alt: 'Mecánico reparando montacargas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/2W4gg5DmVeq9CMT7dn2Hxo/ChatGPT_Image_29_may_2026,_21_10_24.png',
    alt: 'Técnico reparando elevador tipo tijera'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/8P9vwCJiRmLcK6ZFogU2Dy/ChatGPT_Image_29_may_2026,_21_12_02.png',
    alt: 'Mecánicos reparando tractor en campo'
  }];
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroImages.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [heroImages.length]);
  const brands = ['Kalmar', 'Caterpillar', 'Hyster', 'Komatsu', 'John Deere', 'Clark', 'Bellotti', 'Taylor'];
  return <section className="relative bg-primary overflow-hidden pt-20 pb-24 lg:pt-32 lg:pb-32" data-id="element-89">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-90">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" data-id="element-91">
          <defs data-id="element-92">
            <pattern id="diagonal-stripes" width="40" height="40" patternUnits="userSpaceOnUse" patternTransform="rotate(45)" data-id="element-93">
              <rect width="2" height="40" fill="currentColor" data-id="element-94" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#diagonal-stripes)" data-id="element-95" />
        </svg>
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-primary/80 to-transparent" data-id="element-96"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-97">
        {/* Top bar with logo */}
        <div className="flex justify-center lg:justify-start mb-12 lg:mb-16" data-id="element-98">
          <div className="bg-white rounded-2xl px-5 py-3 shadow-lg" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/mweXvrgaEZY11ir22wxP6X/ChatGPT_Image_29_may_2026,_23_22_02.png" alt="2 de Abril SRL — Reparación de equipos pesados" className="h-20 sm:h-24 w-auto object-contain" data-id="element-100" />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-101">
          {/* Content Column */}
          <div className="flex-1 text-center lg:text-left" data-id="element-102">
            <div className="inline-flex items-center gap-2 mb-6" data-id="element-103">
              <span className="w-2 h-2 rounded-full bg-accent" data-id="element-104"></span>
              <span className="text-accent text-sm font-bold tracking-wider uppercase" data-id="element-105">
                2 de Abril SRL — Reparación & Mantenimiento Industrial
              </span>
            </div>

            <h1 className="text-white font-heading font-bold mb-6" data-id="element-106">
              ¿Tu montacargas parado te está{' '}
              <span className="text-accent" data-id="element-107">COSTANDO PLATA</span>?
            </h1>

            <p className="text-subtitle text-lg mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-108">
              Más de 20 años reparando los equipos más exigentes del mercado.
              Diagnóstico in situ, respuesta inmediata y atención personalizada.
              Cubrimos toda la Argentina.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-10" data-id="element-109">
              <WhatsAppButton href="https://wa.me/5491161279601?text=Hola%20Ramón%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Hablar con Ramón" variant="primary" className="w-full sm:w-auto" data-id="element-110" />
              <WhatsAppButton href="https://wa.me/5491121707246?text=Hola%20Marcelo%2C%20quiero%20agendar%20una%20inspección%20técnica%20para%20mi%20equipo" text="Hablar con Marcelo" variant="secondary" className="w-full sm:w-auto" data-id="element-111" />
            </div>

            <div className="flex justify-center lg:justify-start" data-id="element-112">
              <BrandChips brands={brands} data-id="element-113" />
            </div>
          </div>

          {/* Image Column - Carousel */}
          <div className="flex-1 w-full max-w-xl lg:max-w-none" data-id="element-114">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-accent/20" data-id="element-115">
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay z-20 pointer-events-none" data-id="element-116"></div>

              {/* Slides */}
              <div className="relative aspect-[3/2] w-full" data-id="element-117">
                {heroImages.map((image, index) => <img key={index} src={image.src} alt={image.alt} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-118" />)}
              </div>

              {/* Dot indicators */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-30 flex gap-2" data-id="element-119">
                {heroImages.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} aria-label={`Ir a la imagen ${index + 1}`} className={`h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-8 bg-accent' : 'w-2 bg-white/60 hover:bg-white/90'}`} data-id="element-120" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}